import { ways } from "@/mocks/resources";

const toneMap: Record<string, { box: string; icon: string; badge: string }> = {
  primary: { box: "bg-primary-50 border-primary-200", icon: "bg-primary-500 text-background-50", badge: "bg-primary-100 text-primary-700" },
  accent: { box: "bg-accent-50 border-accent-200", icon: "bg-accent-500 text-background-50", badge: "bg-accent-100 text-accent-700" },
  secondary: { box: "bg-secondary-50 border-secondary-200", icon: "bg-secondary-500 text-background-50", badge: "bg-secondary-100 text-secondary-900" },
};

export default function GetWays() {
  return (
    <section id="ways" className="scroll-mt-20 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-medium text-primary-600">四种获取方式</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              用哪种方式，随你挑
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            每种资源都标注可用获取方式，按你习惯的格式筛选，快速锁定有效链接，告别反复试错。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ways.map((w) => {
            const t = toneMap[w.tone];
            return (
              <article key={w.key} className={`rounded-lg border p-5 ${t.box}`}>
                <span className={`flex h-12 w-12 items-center justify-center rounded-md text-xl ${t.icon}`}>
                  <i className={w.icon}></i>
                </span>
                <h3 className="mt-4 flex items-center gap-2 text-base font-semibold text-foreground-950">
                  {w.title}
                  <span className={`rounded-full px-2 py-0.5 text-xs ${t.badge}`}>{w.key}</span>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{w.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}